<div class="flex flex-col gap-4 w-full max-w-4xl">
  <h2 mat-dialog-title class="text-xl font-semibold">Subunit Details</h2>

  <mat-dialog-content class="mat-dialog-content">
    <div *ngIf="subunits.length === 0" class="text-center py-8">
      <p>No subunits found for this license.</p>
    </div>

    <div *ngIf="subunits.length > 0">
      <table mat-table [dataSource]="subunits" multiTemplateDataRows class="portal-table">

        <!-- License ID -->
        <ng-container matColumnDef="licenseId">
          <th mat-header-cell *matHeaderCellDef> License ID </th>
          <td mat-cell *matCellDef="let element"> {{element.licenseId}} </td>
        </ng-container>

        <!-- Entity Name -->
        <ng-container matColumnDef="entityName">
          <th mat-header-cell *matHeaderCellDef> Entity Name </th>
          <td mat-cell *matCellDef="let element"> {{element.entityName}} </td>
        </ng-container>

        <!-- Classification Level -->
        <ng-container matColumnDef="classificationLevel">
          <th mat-header-cell *matHeaderCellDef> Classification </th>
          <td mat-cell *matCellDef="let element"> {{element.classificationLevel}} </td>
        </ng-container>

        <!-- Expiration Date -->
        <ng-container matColumnDef="expirationDate">
          <th mat-header-cell *matHeaderCellDef> Expires </th>
          <td mat-cell *matCellDef="let element"> {{element.expirationDate}} </td>
        </ng-container>

        <!-- Expand/Collapse Button -->
        <ng-container matColumnDef="expand">
          <th mat-header-cell *matHeaderCellDef></th>
          <td mat-cell *matCellDef="let element">
            <button mat-icon-button (click)="$event.stopPropagation(); toggleExpanded(element)">
              <mat-icon>
                {{ expandedElement === element ? 'expand_less' : 'expand_more' }}
              </mat-icon>
            </button>
          </td>
        </ng-container>

        <!-- Expanded Detail Row -->
        <ng-container matColumnDef="expandedDetail">
          <td mat-cell *matCellDef="let element" [attr.colspan]="displayedColumns.length">
            <div class="detail-content" [@detailExpand]="element === expandedElement ? 'expanded' : 'collapsed'">
              <div class="flex flex-col">
                <div class="flex flex-row gap-4">
                  <span class="font-semibold w-1/5">Admin:</span> {{element.adminDesigneeName}}
                </div>
                <div class="flex flex-row gap-4">
                  <span class="font-semibold w-1/5">Phone:</span> {{element.agencyPhone}}
                </div>
                <div class="flex flex-row gap-4">
                  <span class="font-semibold w-1/5">Email:</span> {{element.agencyEmail}}
                </div>
                <div class="flex flex-row gap-4">
                  <span class="font-semibold w-1/5">Distance:</span> {{element.calculatedDistance}} miles
                </div>
              </div>
            </div>
          </td>
        </ng-container>

        <!-- Header row -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>

        <!-- Data row -->
        <tr mat-row *matRowDef="let element; columns: displayedColumns"
            class="element-row"
            [class.expanded]="expandedElement === element"
            (click)="toggleExpanded(element)">
        </tr>

        <!-- Detail row -->
        <tr mat-row *matRowDef="let element; columns: ['expandedDetail']"
            class="detail-row"></tr>

      </table>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="close()">Close</button>
  </mat-dialog-actions>
</div>
